import Swiper from 'swiper';
import SwiperCore, { Autoplay } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Autoplay]);

export default class AnnouncementCarousel {
    /**
     * Class constructor
     * @arg {object} - `sliderElement` check for the
     * announcement carousel element.
     **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.init()
    }

    init() {
        // Get the desktop slides per view setting from data attribute
        const desktopSlidesPerView = this.sliderElement.dataset.desktopSlidesPerView || '1';
        const totalSlides = this.sliderElement.querySelectorAll('.swiper-slide').length;
        
        // Only enable autoplay if there are more slides than what's visible on desktop
        const shouldAutoplay = totalSlides > parseInt(desktopSlidesPerView);
        
        
        new Swiper(this.sliderElement, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            loop: shouldAutoplay,
            loopedSlides: shouldAutoplay ? totalSlides : null,
            autoplay: shouldAutoplay ? {
                delay: 8000,
                disableOnInteraction: false,
            } : false,
            speed: 1000,
            allowTouchMove: true,
            simulateTouch: false,
            breakpoints: {
                1024: {
                    slidesPerView: parseInt(desktopSlidesPerView),
                    slidesPerGroup: 1,
                    allowTouchMove: false,
                    simulateTouch: false
                }
            },
            on: {
                init: function() {
                    const wrapper = this.el.querySelector('.swiper-wrapper');
                    if (wrapper) {
                        wrapper.classList.remove('opacity-0');
                        wrapper.classList.add('opacity-100');
                    }
                }
            }
        });

    }

}
